import { Box, Grid, Typography } from '@mui/material'
import { IVoidDisplay } from './interface'
import Block from '@mui/icons-material/Block'

export function VoidDisplay(props: IVoidDisplay) {
    return (
        <Grid container>
            <Grid item>
                <Block />
            </Grid>
            <Grid item>
                <Box ml={1}>
                    <Typography>Void</Typography>
                    <Typography style={{ fontSize: 12 }}>
                        {props.reason || ''}
                        {props.note ? ` - ${props.note}` : ''}
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    )
}
